import script from "./ContactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactModal.vue?vue&type=script&setup=true&lang=js"

import "./ContactModal.vue?vue&type=style&index=0&id=7ba5dd6d&lang=scss"

const __exports__ = script;

export default __exports__